<div class="container">
    <div class="row align-items-center">
        <div class="col-12">
            <h3 class="cm-title reply-msg">Reporte generado</h3>
        </div>
        <div class="col-12">
            <p>El reporte estará disponible por 60 minutos</p>
        </div>
        <div class="col-12 d-flex justify-content-center">
          <button mat-dialog-close mat-raised-button color="primary" (click)="downloadReport()">Descargar</button>
      </div>
    </div>
</div>
